import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';

import css from './Podium.module.scss';

const Podium = () => {
    const { t } = useTranslateLpc('common');
    return (
        <>
            <>
                <div className={css.podium_container}>
                    <div className={css.place}>
                        <div>
                            <img src={'/front-static/icons/pot/categories/DEPARTURE_KITTY.svg'} alt={'Pot de départ'} />
                            <h3>{t('select.pot-category.DEPARTURE_KITTY')}</h3>
                        </div>
                        <div className={css.second}>
                            <h1>2</h1>
                        </div>
                    </div>
                    <div className={css.place}>
                        <div>
                            <img src={'/front-static/icons/pot/categories/BIRTHDAY.svg'} alt={'Anniversaire'} />
                            <h3>{t('select.pot-category.BIRTHDAY')}</h3>
                        </div>
                        <div className={css.first}>
                            <h1>1</h1>
                        </div>
                    </div>
                    <div className={css.place}>
                        <div>
                            <img src={'/front-static/icons/pot/categories/COMMON_GIFT.svg'} alt={'Cadeau commun'} />
                            <h3>{t('select.pot-category.COMMON_GIFT')}</h3>
                        </div>
                        <div className={css.third}>
                            <h1>3</h1>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};

export default Podium;
